<template>
  <BaseModule
    v-bind="$props"
    class="module-basic-optin container"
    data-module="basic-optin"
  >
    <div class="content">
      <header
        v-if="title"
        class="base-title-fontsize"
      >
        <component
          :is="titleTag"
          class="tit tit-g"
        >
          {{ title }}
        </component>
      </header>
      <form
        id="form-basic-optin"
        class="form-base form-optin clearfix"
        novalidate
        @submit.prevent="send"
      >
        <div
          class="field"
          :class="{ error: !isValidContactName }"
        >
          <input
            :id="`name-${moduleId}`"
            v-model.trim="contactName"
            name="name"
            type="text"
            :placeholder="$t('placeholderName')"
            @blur="startValidate(`name-${moduleId}`)"
          />
        </div>
        <div
          class="field"
          :class="{ error: !isValidContactSurname }"
        >
          <input
            :id="`surname-${moduleId}`"
            v-model.trim="contactSurname"
            name="surname"
            type="text"
            :placeholder="$t('placeholderLastName')"
            @blur="startValidate(`surname-${moduleId}`)"
          />
        </div>
        <div
          class="field"
          :class="{ error: !isValidContactEmail }"
        >
          <input
            :id="`email-${moduleId}`"
            v-model.trim="contactEmail"
            name="email"
            type="email"
            placeholder="E-mail*"
            @blur="startValidate(`email-${moduleId}`)"
          />
        </div>
        <div class="field buttons">
          <!-- popup exclusivo do Editor -->
          <div class="editor-form-disclaimer">
            <span class="slb-tooltip arrow-right-down">
              Os envios de formulários são desativados no preview. Para testar
              seu funcionamento, acesse sua página publicada.
            </span>
            <!-- botão desabilitado no Editor -->
            <button
              type="submit"
              class="cta"
              :disabled="true"
            >
              {{ submitButtonLabel }}
            </button>
          </div>
        </div>
        <div class="form-base__optin txt">
          <input
            :id="optinId"
            v-model="contactOptin"
            type="checkbox"
            :class="{ error: !isValidContactOptin }"
            @blur="startValidate('optin')"
          />
          <label
            ref="consentText"
            :for="optinId"
          >
            <span v-html="consentText"></span>
            <small v-html="consentTextSmall"></small>
          </label>
        </div>
      </form>
      <div
        v-if="wasSent || editing"
        class="form-base__message"
        :class="{
          'form-base__message--success': wasSentWithSuccess,
          'form-base__message--error': !wasSentWithSuccess,
        }"
      >
        <span v-if="wasSentWithSuccess">
          {{ successMessage }}
        </span>
        <span v-else>
          {{ $t('errorMessage') }}
        </span>
      </div>
    </div>
  </BaseModule>
</template>

<script>
import { mapGetters } from 'vuex';

import base from '@/mixins/base';
import uniqueId from '@/helpers/uniqueId';
import BaseModule from './generic/BaseModule.vue';

export default {
  name: 'BasicOptin',
  components: {
    BaseModule,
  },
  mixins: [base],
  inheritAttrs: false,
  props: {
    ...BaseModule.props,
    backgroundColor: {
      type: String,
      default: '', // overrides default
    },
    titleColor: {
      type: String,
      default: '#ffffff', // overrides default
    },
    textColor: {
      type: String,
      default: '#ffffff', // overrides default
    },
    successMessage: {
      type: String,
      default: '',
    },
    consentText: {
      type: String,
      default: 'Aceito receber comunicações e ofertas do hotel.',
    },
    consentTextSmall: {
      type: String,
      default:
        'Ao enviar, estará ciente de que seus dados serão tratados pelo hotel com a finalidade exclusiva de envio de ações de marketing.',
    },
    idsCRMNovas: {
      type: Array,
      default() {
        return [];
      },
    },
    idsCRMExistentes: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      contactName: '',
      contactSurname: '',
      contactEmail: '',
      contactOptin: false,
      optinId: null,
      isSending: false,
      validatingFields: [],
      wasSent: false,
      wasSentWithSuccess: true,
    };
  },
  computed: {
    submitButtonLabel() {
      if (this.isSending) {
        return '...';
      }

      return 'OK';
    },
    idsCRMNovasValid() {
      return this.idsCRMNovas.filter(this.isValidCrmGroupId);
    },
    idsCRMExistentesValid() {
      return this.idsCRMExistentes.filter(this.isValidCrmGroupId);
    },
    editing() {
      return typeof this.$parent === 'undefined';
    },
    isValidContactName() {
      return !this.validatingFields.includes('name') || this.contactName !== '';
    },
    isValidContactSurname() {
      return (
        !this.validatingFields.includes('surname') || this.contactSurname !== ''
      );
    },
    isValidContactEmail() {
      return (
        !this.validatingFields.includes('email') ||
        this.isValidEmail(this.contactEmail)
      );
    },
    isValidContactOptin() {
      return !this.validatingFields.includes('optin') || this.contactOptin;
    },
    moduleId() {
      return this.instanceId.replace(/\D/g, '');
    },
    ...mapGetters(['settings', 'customer', 'apiBaseUrl', 'activePageId']),
  },
  mounted() {
    this.optinId = uniqueId();
  },
  methods: {
    isValid() {
      this.startValidate('name');
      this.startValidate('surname');
      this.startValidate('email');
      this.startValidate('optin');

      return (
        this.isValidContactName &&
        this.isValidContactSurname &&
        this.isValidContactEmail &&
        this.isValidContactOptin
      );
    },
    isValidEmail(email) {
      const emailPattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return emailPattern.test(email);
    },
    isValidCrmGroupId(id) {
      return typeof id === 'string' && /^\d+$/.test(id.trim());
    },
    send() {
      this.wasSent = false;

      if (this.isValid()) {
        this.isSending = true;

        const body = {
          sendEmail: false,
          integrated: true,
          id: this.activePageId,
          url: window.location.href,
          data: {
            name: {
              value: this.contactName,
              label: 'Nome',
            },
            surname: {
              value: this.contactSurname,
              label: 'Sobrenome',
            },
            email: {
              value: this.contactEmail,
              label: 'E-mail',
            },
            consentText: {
              value: this.$refs.consentText.textContent,
              label: 'Texto de consentimento',
            },
            acceptedConsent: {
              value: this.contactOptin,
              label: 'Aceitou o consentimento',
            },
          },
          crmData: {
            groups: this.idsCRMNovasValid.map((id) => ({
              Numgrupo: Number(id),
            })),
            alternativeGroups: this.idsCRMExistentesValid.map((id) => ({
              Numgrupo: Number(id),
            })),
          },
        };

        fetch(`${this.apiBaseUrl}contact/${this.customer}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
          body: JSON.stringify(body),
        })
          .then((res) => {
            this.wasSentWithSuccess = res.status === 200;

            if (this.wasSentWithSuccess) {
              this.resetForm();
            }
          })
          .catch(() => {
            this.wasSentWithSuccess = false;
          })
          .finally(() => {
            this.isSending = false;
            this.wasSent = true;
          });
      }
    },
    resetForm() {
      this.contactName = '';
      this.contactSurname = '';
      this.contactEmail = '';
      this.contactOptin = false;
      this.validatingFields = [];
    },
    startValidate(field) {
      if (!this.validatingFields.includes(field)) {
        this.validatingFields.push(field);
      }
    },
  },
  metadata: {
    extends: BaseModule.metadata,
    tabs: [
      {
        name: 'content',
        groups: [
          {
            name: 'text',
            fields: [
              {
                name: 'successMessage',
                type: 'LongText',
                label: 'Mensagem de confirmação',
              },
              {
                name: 'consentText',
                type: 'Html',
                maxlength: 200,
                label: 'Texto de consentimento',
              },
              {
                name: 'consentTextSmall',
                type: 'Html',
                label: 'Nota de consentimento',
              },
            ],
            toRemove: ['subtitle'],
          },
          {
            name: 'crmGroups',
            label: 'Grupos do CRM',
            fields: [
              {
                name: 'idsCRMNovas',
                type: 'Tags',
                label: 'IDs - Pessoas novas',
                helpText:
                  'Grupos de leads que se cadastraram pela primeira vez',
                pattern: /^\d+$/,
                validation: {
                  presence: {
                    allowEmpty: false,
                    message:
                      'Adicione, no mínimo, um grupo de CRM para pessoas novas',
                  },
                },
              },
              {
                name: 'idsCRMExistentes',
                type: 'Tags',
                label: 'IDs - Pessoas existentes',
                helpText: 'Grupos de leads que se cadastraram novamente',
                pattern: /^\d+$/,
                validation: {
                  presence: {
                    allowEmpty: false,
                    message:
                      'Adicione, no mínimo, um grupo de CRM para pessoas existentes',
                  },
                },
              },
            ],
          },
        ],
      },
      {
        name: 'appearance',
        groups: [
          {
            name: 'fonts',
            toRemove: ['contentSizeDesk', 'contentSizeMobile'],
          },
        ],
      },
    ],
  },
  i18n: {
    messages: {
      pt: {
        placeholderName: 'Nome*',
        placeholderLastName: 'Sobrenome*',
        errorMessage: 'Ops! Algo errado aconteceu ao enviar seu contato.',
      },
      en: {
        placeholderName: 'Name*',
        placeholderLastName: 'Last name*',
        errorMessage:
          'Oops! Something wrong happened when sending your contact.',
      },
      es: {
        placeholderName: 'Nombre*',
        placeholderLastName: 'Apellido*',
        errorMessage: '¡UPS! Ocurrió algo incorrecto al enviar su contacto.',
      },
    },
  },
};
</script>

<style scoped lang="scss">
section.module-basic-optin {
  background-color: var(--bg-color, var(--primary-color));
  padding: 0 55px;
  padding-top: var(--padding-top);
  padding-bottom: var(--padding-bottom);

  .tit {
    color: var(--title-color, $lb-white);
    text-align: left;
  }

  .form-base {
    margin-top: 30px;
    border: 2px solid transparent;
    border-radius: 5px;
    color: $lb-medium-gray;
    font-size: $size-normal;
    transition: 200ms;

    .field {
      float: left;
      margin-bottom: 20px;
      width: calc(50% - 10px);
      margin-top: 0;
      width: 28.5%;
      position: relative;

      input {
        display: block;
        position: relative;
        transition: all 100ms;
        width: 100%;
        height: 50px;
        border: 2px solid transparent;
        border-radius: 5px;
        color: $lb-medium-gray;
        font-size: $size-normal;
        padding: 10px;
      }

      + .field {
        margin-left: 15px;
      }

      .buttons {
        width: 7.5%;

        button {
          padding-left: 0;
          padding-right: 0;
          width: 100%;
          height: 50px;
        }
      }

      &.error {
        input {
          border-color: crimson;
        }

        input[type='text']::placeholder,
        input[type='tel']::placeholder,
        input[type='email']::placeholder {
          color: crimson;
        }
      }
    }

    .buttons {
      width: auto;
    }

    &__optin {
      clear: both;
      color: var(--text-color, $lb-white);
      text-align: left;

      input {
        float: left;
        margin: 0.25em 0.5em 0 0;

        &.error {
          outline: 1px solid crimson;
        }
      }

      small {
        display: block;
        font-size: $size-smaller;
      }
    }

    &__message {
      border: 1px solid #000;
      padding: 1em 2em;
      margin-top: 1em;

      &--success {
        background-color: #d9ffd9;
        border-color: green;
        border-radius: 5px;
        color: green;
      }

      &--error {
        background-color: #fde6eb;
        border-color: crimson;
        border-radius: 5px;
        color: crimson;
      }
    }

    .cta {
      background-color: var(--button-color, var(--secondary-color));
    }
  }
}

@include media-breakpoint-down(sm) {
  section.module-basic-optin {
    padding-top: var(--padding-top-mobile);
    padding-bottom: var(--padding-bottom-mobile);

    .form-base .field {
      margin-left: 0 !important;
      margin-bottom: 10px;
      width: 100% !important;

      button {
        border-radius: 0;
        width: 100%;
      }
    }
  }
}
</style>
